import { ToneDto } from '../../tonedto';

export interface GetWishlistDto
{
    getIdentifier(): string;
    getMsisdn(): string;
    getWishlistType(): string;
    getLanguage(): string;

    getDescription():string;
    getWishlistToneDetailsList():ToneDto[];
}

export class GetWishlistDtoImpl implements GetWishlistDto
{
    private identifier: string;
    private msisdn: string;
    private wishlistType: string;
    private language: string;
    private catagoryId: string;
    private description: string;
    private wishlistToneDetailsList: ToneDto[];

    getIdentifier(): string 
    {
        return this.identifier;
    }
    setIdentifier(identifier: string)
    {
        this.identifier = identifier;
    }

    getMsisdn(): string 
    {
        return this.msisdn;
    }
    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }

    getCatagoryId(): string 
    {
        return this.catagoryId;
    }
    setCatagoryId(catagoryId: string)
    {
        this.catagoryId = catagoryId;
    }

    getLanguage(): string 
    {
        return this.language;
    }
    setLanguage(language: string)
    {
        this.language = language;
    }

    getWishlistType(): string 
    {
        return this.wishlistType;
    }
    setWishlistType(wishlistType: string)
    {
        this.wishlistType = wishlistType;
    }

    getDescription(): string 
    {
        return this.description;
    }
    setDescription(description: string)
    {
        this.description = description;
    }

    getWishlistToneDetailsList(): ToneDto[] 
    {
        return this.wishlistToneDetailsList;
    }
    setWishlistToneDetailsList(wishlistToneDetailsList: ToneDto[])
    {
        this.wishlistToneDetailsList = wishlistToneDetailsList;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/wishlist/getwishlist/getwishlistdto.tsx